"use client";

import { useRef, useEffect } from "react";
import type { Branch } from "@/lib/flatten-dialog";

interface BranchPillsProps {
  branches: Branch[];
  activeBranchIndex: number;
  onSelect: (branchIndex: number) => void;
}

export function BranchPills({ branches, activeBranchIndex, onSelect }: BranchPillsProps) {
  const activeRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    activeRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
  }, [activeBranchIndex]);

  if (branches.length <= 1) return null;

  return (
    <div className="flex gap-2 overflow-x-auto px-4 py-2 scrollbar-none">
      {branches.map((branch) => {
        const isActive = branch.index === activeBranchIndex;
        return (
          <button
            key={branch.index}
            ref={isActive ? activeRef : undefined}
            onClick={() => onSelect(branch.index)}
            className={`
              shrink-0 px-3 py-1.5 rounded-full text-xs font-medium
              transition-all duration-200 whitespace-nowrap
              ${isActive
                ? "bg-primary text-primary-foreground shadow-sm"
                : "bg-muted text-muted-foreground hover:bg-muted/80"
              }
            `}
          >
            {branch.label}
          </button>
        );
      })}
    </div>
  );
}
